<template>
    <button
        v-if="reversed === 'true'"
        class="btn btn--reversed"
        :class="[
            theme === 'dark' ? 'btn__text--dark' : 'btn__text--light',
            variant,
            size,
        ]"
        :type="type"
        @click="$emit('click')"
    >
        <span v-if="value" class="btn__text">{{ value }}</span>
        <img v-if="img" class="btn__img" :src="img" />
    </button>
    <button
        v-else
        class="btn"
        :class="[
            theme === 'dark' ? 'btn__text--dark' : 'btn__text--light',
            variant,
            size,
        ]"
        :type="type"
        @click="$emit('click')"
    >
        <img v-if="img" class="btn__img" :src="img" />
        <span v-if="value" class="btn__text">
            {{ value }}
        </span>
    </button>
</template>

<script>
import Vue from 'vue';
export default Vue.extend({
    name: 'Button',
    props: {
        value: {
            type: String,
            required: false,
        },
        img: {
            type: String,
            required: false,
        },
        reversed: {
            type: String,
            required: false,
            default: 'false',
        },
        type: {
            type: String,
            required: false,
            default: 'button',
        },
        theme: {
            type: String,
            required: false,
            default: 'dark',
        },
        variant: {
            type: String,
            required: false,
        },
        size: {
            type: String,
            required: false,
        },
    },
});
</script>
